import { IonPage, IonIcon } from '@ionic/react';
import React, { useRef, useEffect, useState } from 'react';
// import { pencilOutline } from 'ionicons/icons';
import styled from "styled-components";

const DrawCanvas: React.FC = () => {

    const touchDevice = (navigator.maxTouchPoints || 'ontouchstart' in document.documentElement);

    const canvasRef = useRef<any>(null);
    const contextRef = useRef<any>(null);
    const [isDrawing, setIsDrawing] = useState(false);
    const canvasImgWidth = 600;
    const canvasImgHeigth = 400;
    
    
    useEffect(() => {
        createCanvas();
    }, []);

    const createCanvas = () => {

        const canvas = canvasRef.current;
        const context = canvas.getContext("2d");
        canvas.width = canvasImgWidth;
        canvas.height = canvasImgHeigth;
        context.lineCap = "round";
        context.strokeStyle = "black";
        context.lineWidth = 1;
        contextRef.current = context;
        
        // For Adding the background Image
        // const background = new Image();
        // background.setAttribute('crossOrigin', 'anonymous');
        // background.addEventListener('load', () => {
        //     context.drawImage(background, 0, 0, canvasImgWidth.toString(), canvasImgHeigth.toString());
        //     canvas.append(context);
        // });
        // background.src = "assets/c1.png";

    }

    const startDrawing = (nativeEvent: any) => {
        
        nativeEvent.preventDefault();
        contextRef.current.beginPath();
        if (nativeEvent.type.includes('touch')) {
            const rect = nativeEvent.getBoundingClientRect();

            contextRef.current.moveTo(nativeEvent.touches[0].clientX - rect.left, nativeEvent.touches[0].clientY - rect.top);
            contextRef.current.lineTo(nativeEvent.touches[0].clientX - rect.left, nativeEvent.touches[0].clientY - rect.top);
        } else if (nativeEvent.type == 'mousedown') {
            const { offsetX, offsetY } = nativeEvent;
            contextRef.current.moveTo(offsetX,  offsetY);
            contextRef.current.lineTo(offsetX, offsetY);
        }
        contextRef.current.stroke();
        setIsDrawing(true);
    };
    
    const draw = (nativeEvent : any) => {
        nativeEvent.preventDefault();
        if (!isDrawing) {
            return;
        }

        if (nativeEvent.type.includes('touch')) {
            const rect = nativeEvent.getBoundingClientRect();
            contextRef.current.lineTo(nativeEvent.touches[0].clientX - rect.left, nativeEvent.touches[0].clientY - rect.top);
        } else if (nativeEvent.type == 'mousemove') {
            const { offsetX, offsetY } = nativeEvent;
            contextRef.current.lineTo(offsetX, offsetY);
        }
        contextRef.current.stroke();
    };

    const stopDrawing = () => {
        contextRef.current.closePath();
        setIsDrawing(false);
    };

    const setToDraw = () => {
        contextRef.current.lineWidth = 1;
        contextRef.current.globalCompositeOperation = 'source-over';
    };

    const setToErase = () => {
        contextRef.current.lineWidth = 10;
        contextRef.current.globalCompositeOperation = 'destination-out';
    };
    const setToClear = () => {
        contextRef.current.clearRect(0, 0, canvasImgWidth, canvasImgHeigth);
        createCanvas();
    };

    const saveImageToLocal = (event: any) => {
        let link = event.currentTarget;
        link.setAttribute('download', 'canvas.png');
        let image = canvasRef.current.toDataURL('image/png');
        link.setAttribute('href', image);
    };


    return (
        <DrawCanvasPage>
            <IonPage>
                {touchDevice ?

                    <canvas
                        className="canvas-container"
                        ref={canvasRef}
                        onTouchMove={draw}
                        onTouchEnd={stopDrawing}
                        onTouchStart={startDrawing}
                    >
                    </canvas>
                    :
                    <canvas
                        className="canvas-container"
                        ref={canvasRef}
                        onMouseDown={startDrawing}
                        onMouseMove={draw}
                        onMouseUp={stopDrawing}
                        onMouseLeave={stopDrawing}
                    >
                    </canvas>
                }
                
                <div className="canvas-ctrl">
                
                    <button onClick={setToDraw} className="ion-button">
                    {/* <IonIcon color = "primary" slot="start" icon={pencilOutline} style={{fontSize : "40px", paddingTop: "10px"}} /> */}
                        Draw
                    </button>
                    <button onClick={setToErase} className="ion-button">
                        Erase
                    </button>
                    
                    <button className="ion-button" onClick={setToClear}>
                        Clear
                    </button>
                    <a className="download_link"id="download_image_link" href="download_link" onClick={saveImageToLocal}>Download</a>
                </div>
            </IonPage>
        </DrawCanvasPage>
    )
};

const DrawCanvasPage = styled(IonPage)
    `.canvas-container {
        width: 600px;
        heigth: 400px;
        border: 2px solid #000;
        cursor: crosshair;
    }
    .ion-button{
        padding: 8px;
        background-color: #019849;
        color:#ffffff;
        
      }
      .ion-button:hover, .ion-button:active {
        background-color: #38c87c;
      }

      .download_link {
        text-decoration: none;
        padding: 7.5px;
        background-color: #019849;
        color: #ffffff;
        font-size: 13px;
        /* margin-top: 11px; */
        position: relative;
        top: 1px;
      }

      .ion-page{
        justify-content: center;
        align-items: center;
        padding: 10px;
      }
      .canvas-ctrl {
        margin-top: 10px;
      }
    `;
export default DrawCanvas;



